import React from 'react';

export default function FirstUpper(props: { children?: string }) {
	const { children } = props;

	if (!children) {
		return null;
	}
	return <>{firstUpperString(children)}</>;
}

export const firstUpperString = (text: string): string => {
	return text.charAt(0).toUpperCase() + text.slice(1);
};
